import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ViajesService } from 'src/app/_services/viajes.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {
  imagenDefault = '../assets/images/body/tours/01.jpg';
  paquetes: any [] = [];
  etiqueta: boolean = true; 

  constructor(
    private viajesService: ViajesService
  ) { }

  ngOnInit(): void {
    this.getViajesMasVendidos();
  }
  getViajesMasVendidos(){
    this.viajesService.getPaquetesTop().subscribe(data => {
      if(data instanceof HttpResponse) { 
        this.paquetes = data.body.list;       
      }           
    });      
  }

  getViajes(){
    this.etiqueta = false;
    this.paquetes = []; 
    this.viajesService.getViajes('1', '').subscribe(data => {
      if(data instanceof HttpResponse) { 
        this.paquetes = data.body.list;            
      }             
    });  
  }

}
